var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-modal',_vm._g({attrs:{"ctas":_vm.ctas,"title":_vm.i18nContent.title,"text":_vm.i18nContent.text,"value":_vm.value}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }